import React from 'react';
import {FormProvider, useForm} from "react-hook-form";
import {Row} from "react-bootstrap";
import SectionHeader from "../sectionHeader/SeactionHeader";
import MeasuresFormShow from "../../../components/MeasuresForm/MeasuresFormShow";
import {useUserContext} from "../../../contexts/UserContext";

function MeasureTab({propsObj}) {
    const {open,setOpen,idx,responsiblePersonRisk,userInChargeRisk,item,schema,setDisabled,id,riskStatusId,allowNewMeasure,setScheme,disabled,estimatedGrossLost} = propsObj;
    const methods = useForm(schema);
    const user = useUserContext();

    const toggle = (event) => {
        if (parseInt(event?.target?.id) === open) {
            setOpen('');
        } else if (parseInt(event?.target?.id) !== open) {
            setOpen('');
            setOpen(parseInt(event?.target?.id));
        }
    };
    return (
        <FormProvider key={idx} {...methods}>
            <Row className={`px-5 mt-3 py-3`} key={idx}>
                <div
                    className={`w-100 measure-section-container ${
                        open === idx && 'open'
                    }`}
                >
                    <SectionHeader
                        data={item}
                        // open je aktivna measure i ako je jednaka indexu onda je open true
                        open={open === idx ? true : false}
                        toggleOpen={(event) => toggle(event)}
                        key={idx}
                        value={idx}
                        setDisabled={setDisabled}
                    />
                    <div
                        className={`section-content ${open === idx && 'open'}`}
                    >
                        <div className="measure-form">
                            <MeasuresFormShow
                                data={item}
                                open={open === idx ? true : false}
                                toggleOpen={(event) => toggle(event)}
                                key={idx}
                                userData={user}
                                userResponsibleRisk={responsiblePersonRisk}
                                userInCharge={userInChargeRisk}
                                value={idx}
                                riskId={id}
                                riskStatusId={riskStatusId}
                                estimatedGrossLost={estimatedGrossLost}
                                allowEdit={allowNewMeasure}
                                disabled={disabled}
                                setDisabled={setDisabled}
                                setScheme={setScheme}
                            />
                        </div>
                    </div>
                </div>
            </Row>
        </FormProvider>
    );
}

export default MeasureTab;